import Cookies from "js-cookie"
import { html } from "lit-html"
import { virtual, useEffect, useState } from "haunted"
import { unsafeHTML } from "lit-html/directives/unsafe-html.js"
import { ROLE_ICON_MAP } from "../constants"

export const FeedbackComponent = virtual(({ endpoint }) => {
  const PAGE_SIZE = 10

  const [loading, setLoading] = useState(true)
  const [roleList, setRoleList] = useState([])
  const [numOfDisplayedRoles, setNumOfDisplayedRoles] = useState(0)
  const csrftoken = Cookies.get("csrftoken")

  const loadFeedback = () => {
    fetch(endpoint, {
      method: "GET",
      credentials: "include",
      headers: {
        "X-CSRFToken": csrftoken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setRoleList(res)
        setNumOfDisplayedRoles(Math.min(PAGE_SIZE, res.length))
        setLoading(false)
      })
      .catch((err) => console.error(err))
  }

  useEffect(loadFeedback, [])

  const FeedbackRow = (
    feedback,
    assignment,
    url,
    category,
    isFirstCommenter
  ) => {
    return html`
      <div id="feedback-${feedback.id}">
        <div class="mb-2 flex items-center">
          <span
            class="mr-6 border-px border-gray-border rounded-full w-44 min-w-44 h-44 bg-tag-bg-${feedback
              .commenter
              .initials_color} flex items-center justify-center text-tag-text-${feedback
              .commenter.initials_color} uppercase"
          >
            ${feedback.commenter.initials}
          </span>
          <span class="flex flex-row flex-wrap text-gray-600">
            <a href=${feedback.commenter.url}>${feedback.commenter.name}</a>
            ${isFirstCommenter
              ? html`
                  &nbsp; left feedback on &nbsp;
                  <a href=${url} class="mr-5 underline font-bold"">${assignment}</a>
                  <a
                    class="role-icon-link icon-inline rounded hover:border-none ${category}"
                    href=${url}
                  >
                    <i
                      class="${
                        category in ROLE_ICON_MAP
                          ? ROLE_ICON_MAP[category]
                          : "fas fa-pen-alt"
                      } text-xtiny"
                    >
                    </i>
                  </a>
                `
              : html``}
          </span>
        </div>
        <div class="mb-4 ml-13">${unsafeHTML(feedback.comment)}</div>
        <div class="mb-6 ml-13 text-gray-600 text-sm">
          ${feedback.created_at}
        </div>
      </div>
    `
  }

  const RoleFeedbackSection = ({ id, assignment, url, category, feedback }) => {
    return html`
      <div
        id="role-feedback-${id}"
        class="border-b-px border-gray-border px-7 pt-8 pb-6"
      >
        ${feedback.map((fb, index) =>
          FeedbackRow(fb, assignment, url, category, index === 0)
        )}
      </div>
    `
  }

  const content = roleList
    .slice(0, numOfDisplayedRoles)
    .map((role) => RoleFeedbackSection(role))

  const seeMoreFeedback = () => {
    setNumOfDisplayedRoles(
      Math.min(numOfDisplayedRoles + PAGE_SIZE, roleList.length)
    )
  }

  const seeMoreFeedbackComponent = () => {
    return html`
      <div class="mb-9 w-full text-center">
        <button
          type="button"
          @click=${seeMoreFeedback}
          class="button m-0 w-full h-10 border-gray-border rounded-xxl grow-1 text-center text-black"
        >
          Load more
        </button>
      </div>
    `
  }

  return html`
    <div
      class="mb-9half border-px border-gray-border shadow-select-box rounded-md pt-8 text-black"
    >
      <div class="mb-8 px-7 text-xl font-serif font-bold">Feedback</div>
      ${loading ? html` <div class="loader-container loading"></div>` : content}
    </div>
    ${numOfDisplayedRoles < roleList.length
      ? seeMoreFeedbackComponent()
      : html``}
  `
})
